export { default as Facebook } from "./Facebook";
export { default as Instagram } from "./Instagram";
export { default as Wordpress } from "./Wordpress";
export { default as Linkedin } from "./Linkedin";
export { default as Twitter } from "./Twitter";
export { default as Youtube } from "./Youtube";
export { default as Github } from "./Github";
